export class Date {
    public year: number;
    public month: number;
    public day: number;
    constructor(obj?: { year?: number; month?: number; day?: number }) {
        if (obj != null) {
            this.year = typeof obj.year === 'undefined' ? this.year : obj.year;
            this.month = typeof obj.month === 'undefined' ? this.month : obj.month;
            this.day = typeof obj.day === 'undefined' ? this.day : obj.day;
        }
    }
}
